import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubuser } from "../../../actions/subuserAction";

import BreadcrumbCom from "../../BreadcrumbCom";
import EmptyCardError from "../../EmptyCardError";
import PageTitle from "../../Helpers/PageTitle";
import Layout from "../../Partials/Layout";
import UserEditForm from "./UserEditForm";

export default function EditUser({ cart = true }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //validate user
  const { search } = useLocation(); //search is gonna be "/Home"
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/Login"; // check if redirect url exist

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  //get URL parameter
  const params = new URLSearchParams(location.search);
  const subuserId = params.get("subuserId");

  // get subuser information from API
  const subuserInfoFromAPI = useSelector((state) => state.getSubuser);
  const { loading, error, subuser } = subuserInfoFromAPI;

  useEffect(() => {
    if (!userInfo) {
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logined ");
    }
    dispatch(getSubuser(subuserId));
  }, [dispatch, navigate, redirect, userInfo]);

  return (
    <Layout childrenClasses={cart ? "pt-0 pb-0" : ""}>
      {cart === false ? (
        <div className="cart-page-wrapper w-full">
          <div className="container-x mx-auto">
            <BreadcrumbCom
              paths={[
                { name: "home", path: "/" },
                { name: "Sub-Users", path: "/customerusers" },
                { name: "Edit Sub-Users", path: "/edituser" },
              ]}
            />
            <EmptyCardError />
          </div>
        </div>
      ) : (
        <div className="cart-page-wrapper w-full bg-white pb-[60px]">
          <div className="w-full h-25">
            <PageTitle
              title="Edit Customer User"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "Sub-Users", path: "/customerusers" },
                { name: "Edit Sub-Users", path: "/edituser" },
              ]}
            />
          </div>

          <div className="w-full mt-[23px]">
            <div className="container-x mx-auto">
              <UserEditForm className="mb-[30px]" subuser={subuser} />

              <div className="w-full mt-[30px] flex sm:justify-end"></div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
